/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type CommentSeenContextLocal = {
    readonly enableCommentSeen: boolean;
    readonly enableZKey: boolean;
    readonly " $refType": "CommentSeenContextLocal";
};
export type CommentSeenContextLocal$data = CommentSeenContextLocal;
export type CommentSeenContextLocal$key = {
    readonly " $data"?: CommentSeenContextLocal$data;
    readonly " $fragmentRefs": FragmentRefs<"CommentSeenContextLocal">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "CommentSeenContextLocal",
    "selections": [
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "enableCommentSeen",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "enableZKey",
                    "storageKey": null
                }
            ]
        }
    ],
    "type": "Local",
    "abstractKey": null
} as any);
(node as any).hash = '390af113ce9aaa5c784654d4ee73d8db';
export default node;
